'use client';

import MoonIcon from '@/assets/svgs/moon-filled.svg';
import SunIcon from '@/assets/svgs/sun-filled.svg';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

export default function ThemeSwitcher() {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div className="h-9" />;
  }

  // Use resolvedTheme (the theme actually applied) so the toggle's state
  // matches what's on screen instead of the stored preference value.
  const isDark = resolvedTheme === 'dark';

  const toggleTheme = () => {
    setTheme(isDark ? 'light' : 'dark');
  };

  return (
    <div className="mb-2 w-full px-3">
      <label className="toggle toggle-lg">
        <input type="checkbox" checked={isDark} onChange={toggleTheme} />
        <SunIcon aria-label="enabled" />
        <MoonIcon aria-label="disabled" />
      </label>
    </div>
  );
}
